module.exports = __webpack_public_path__ + "img/logo-white-full.c65c50a.png";